<template>
	<div>
		<!-- Membership card -->
		<v-container>
			<v-card>
				<v-img
					v-if="user.hero_image"
					class="white--text align-end"
					height="200px"
					:src="user.hero_image.url"
					gradient="rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, .6) 100%"
					dark
				>
					<!-- aspect-ratio="1.628" -->
					<v-card-title class="headline">
						{{user.firstname}} {{user.lastname}}
					</v-card-title>
					<v-card-subtitle v-if="user.membership" class="white--text">
						{{user.membership}}
					</v-card-subtitle>
				</v-img>
				<template v-else>
					<v-card-title class="headline">
						{{user.firstname}} {{user.lastname}}
					</v-card-title>
					<v-card-subtitle v-if="user.membership">
						{{user.membership}}
					</v-card-subtitle>
				</template>
				<v-card-text v-if="user.details && user.details.length">
					<v-list two-line>
						<template v-for="(detail, index) in user.details">
							<v-list-item :key="detail.id">
								<v-list-item-icon v-if="detail.icon">
									<v-icon color="accent">{{detail.icon}}</v-icon>
								</v-list-item-icon>

								<v-list-item-content>
									<v-list-item-subtitle v-if="detail.label">
										{{detail.label}}
									</v-list-item-subtitle>
									<v-list-item-title v-if="detail.value">
										{{detail.value}}
									</v-list-item-title>
								</v-list-item-content>
							</v-list-item>
							<v-divider
								v-show="index != user.details.length -1"
								:key="('divider-' + index)"
								inset
							/>
						</template>
					</v-list>
				</v-card-text>
				<v-btn
					v-if="$router.options.routes.find(route => route.name == 'myAccount')"
					:to="{ name: 'myAccount' }"
					fab
					absolute
					right
					bottom
					small
					color="secondary"
				>
					<v-icon>mdi-pencil</v-icon>
				</v-btn>
			</v-card>
		</v-container>

		<!-- Extra details -->
		<v-container v-if="user.panels && user.panels.length">
			<v-expansion-panels>
				<v-expansion-panel
					v-for="(item, index) in user.panels"
					:key="index"
					v-bind="item.props ? item.props : null"
				>
					<v-expansion-panel-header>
						{{item.title}}
					</v-expansion-panel-header>
					<v-expansion-panel-content>
						<div
							v-html="item.content"
							class="copy"
						/>
					</v-expansion-panel-content>
				</v-expansion-panel>
			</v-expansion-panels>
		</v-container>

		<!-- Benefit cards 
		<v-container v-if="benefits.length" class="py-0">
			<v-row>
				<v-col
					v-for="item in benefits"
					:key="item.id"
					cols="12"
					sm="6"
				>
					<v-card
						:to="{ name: 'benefit', params: { pagename: item.name } }"
						height="100%"
					>
						<v-row>
							<v-col
								:cols="(item.logo) ? 8 : 12"
								class="pb-0"
							>
								<v-card-title
									v-if="item.title"
									class="pt-0"
								>
									{{item.title}}
								</v-card-title>
							</v-col>
							<v-col
								v-if="item.logo"
								cols="4"
							>
								<div class="pt-1 pr-3">
									<v-img
										:src="item.logo.url"
										contain
									/>
								</div>
							</v-col>
						</v-row>

						<v-card-text class="pt-0">
							{{item.summary}}
						</v-card-text>
					</v-card>
				</v-col>
			</v-row>
		</v-container>
		-->
	</div>
</template>

<script>

import { mapState } from 'vuex'

export default {
	name: 'membershipCard',
	computed: {
		...mapState([
			'user',
			'benefits',
		]),
	},
	mounted () {
		this.$api.Me.doRequest()
	},
}
</script>
